export default __webpack_public_path__ + "static/media/unleash_logo_icon_dark _ alpha.07e50ae2.gif";